import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

export const useIsListingManagerEditingEnabled = (venue?: Venue) => {
  const { user } = useUser();

  const {
    data: featureFlags,
    isInitialLoading,
    error,
  } = useFeatureFlags(['enable_listing_manager_editing'], {
    user_email: user?.email || '',
    user_id: user?.id || '',
    venue_id: venue?.id || '',
    venue_country: venue?.country || '',
  });

  const shouldEnableByDefaultAsFallback = !!error;

  return {
    isListingManagerEditingEnabled:
      featureFlags?.enable_listing_manager_editing === 'on' || shouldEnableByDefaultAsFallback,
    isListingManagerEditingEnabledLoading: isInitialLoading,
  };
};
